<script>
import DropZone from './DropZone.svelte';
import {Card} from 'sveltestrap';
import {createDatasource, upload} from './datasets.js';
import {createRecFromFiles, store } from './recs';
import {save as saveSettings} from './settings.js'
import { global } from './state.js'
import { hashPut } from './hash.js'

let claz = "col";
export { claz as class };

let err;
let clear_signal=false;
let clear=false;
let added = false
let preaddcount = 0

async function handle(files) {
  console.log('handle',files)
  clear = false;
  added = true
  preaddcount = $store.list.length
  err = await createRecFromFiles(files);
  clear=true;
}

$: { 
  clear_signal = clear; 

  //console.log("QuickDrop $ ", $store.list)

  if (added && $store.list.length != preaddcount) {
    added = false;
    hashPut("workspace", $store.list.slice(-1).shift().id)
  }
}

</script>
<style>
.errmsg { 
  color: red;
  background-color: grey;
}
</style>

    <Card body class="{claz}">
      {#if err} 
      <div class='errmsg'>
         {err}
      </div>
      {/if} 
      <DropZone multi={true} handleFiles={handle} clear={clear_signal} />
    </Card>
